module.exports = __webpack_public_path__ + "assets/img/4.a716a217.png";